import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'toJsDate',
    standalone: false
})
export class ToJsDatePipe extends DatePipe implements PipeTransform {
    transform(value: string | Date): any {
        return new Date(value);
    }
}
